module.exports = __webpack_public_path__ + "media/images/design/images/crowd_funding/btn_shimane_shakai_koukenkikin-8f283318625a6bc7baf085f86f57f09d.png";